import AbstractValidator from './AbstractValidator';

export default class Time extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notTime: 'Die eingebenene Uhrzeit (%value%) ist nicht im richtigen Format (HH:MM).',
        timeBeforeMinTime: 'Die eingebenene Uhrzeit (%value%) liegt vor der angegebenen Uhrzeit.',
        timePastMaxTime: 'Die eingebenene Uhrzeit (%value%) liegt nach der angegebenen Uhrzeit.',
    };

    run()
    {
        if (!this.value.match(/^((([0-1]?[0-9]|2[0-3]):[0-5]?[0-9])|24:0{1,2})(:\d{2})?$/))
        {
            this.error = this.getMessage('notTime');
        }
    }
}